import React from "react";

import { Link } from "react-router-dom";

import { Button, Pane, Typography } from "clearsense-ui/components";
import { Download, Plus, Upload } from "components/Common/clearsense-ui/icons";

const ListElement = ({ icon, content = "", onClick }) => (
  <Typography
    style="condensedMedium"
    type="semibold"
    className="flex items-center gap-2 p-2 transition duration-300 cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 w-max"
    onClick={onClick}
    data-cy="upload-reference-source-option"
  >
    {icon}
    {content}
  </Typography>
);

const ReferenceSourceFormType = ({ setReferenceSourceFormType, onClose }) => (
  <>
    <Pane.Header>
      <Typography style="h3" type="bold" className="-mt-3">
        Create Reference Source
      </Typography>

      <Typography style="large">
        Create a Reference Source with the options below
      </Typography>
    </Pane.Header>

    <Pane.Body>
      <div className="py-8 flex w-full flex-col gap-4 overflow-auto">
        <div className="flex items-center">
          <ListElement
            icon={<Upload color="gray" size={15} />}
            content="Upload a Reference Source"
            onClick={() => setReferenceSourceFormType("upload")}
          />
          <Link to="/sample_reference_source.csv" target="_blank" download>
            <Typography
              style="small"
              className="flex items-center gap-2 text-indigo-600 dark:text-indigo-400"
            >
              [<Download size={15} /> Download Reference Data Template ]
            </Typography>
          </Link>
        </div>
        <ListElement
          icon={<Plus color="gray" size={15} />}
          content="Create New Reference Source"
          onClick={() => setReferenceSourceFormType("new")}
        />
      </div>
    </Pane.Body>

    <Pane.Footer className="gap-2 flex items-center justify-between w-full">
      <Button
        label="Cancel"
        style="secondary"
        type="button"
        onClick={onClose}
        data-cy="ref-source-cancel-button"
      />
    </Pane.Footer>
  </>
);

export default ReferenceSourceFormType;
